export const MUI_DATE_PICKER_ES_LOCALE_TEXT = {
  cancelButtonLabel: 'Cancelar',
  okButtonLabel: 'Confirmar',
  datePickerToolbarTitle: 'Selecciona fecha'
}

